import { Box, Button, Typography } from "@mui/material"
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { MapCustomSubscription } from "../../../components/Table/mapping-function/TableMapping";
import { Link } from "react-router-dom";


export const AdminCustomSubscription = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [randomNum, setRandomNum] = useState(Math.round(Math.random() * (5000 - 5 + 1)) + 5);
    // const [tableData, setTableData] = useState(MapCustomSubscription(new Array(Math.round(Math.random() * (5000 - 5 + 1)) + 5).fill(4)));
    const [filter1, setFilter1] = useState(null);
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [threedotss, setThreeDotss] = useState(true);
    const dispatch = useDispatch()
    const tbl = MapCustomSubscription(new Array(randomNum).fill(4))

    const prop = {
        // title: 'Manage Plan',
        borderBoxStyle: { px: 0 },
        goto: true,
        // searchTerm,
        // setSearchTerm,
        filteredData: tbl,
        // filteredData: tableData,
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000' },
        rowsPerPage,
        page,
        setPage,
        tableStyle: { Invoice: false, OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, },
    }
    return (
        <Box sx={{ width: '100%', }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography sx={{ color: '#000000', fontSize: '20px', fontWeight: '600' }}>Custom Subscription</Typography>
                <Link to={'/admin/new-subscription'}>
                    <Button disableRipple sx={{ textTransform: 'capitalize', minHeight: 'max-content', minWidth: 'max-content', height: '26px', width: '64px', background: '#FF2800', color: '#fff', '&:hover': { background: '#FF2800' }, }}>+ New Subscription</Button>
                </Link>
            </Box>
            <PackageTable prop={prop} />
        </Box>
    )
}